/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod/v4';

export const upsertItemTypeRequestSchema = z.object({
  color: z.string().nullish(),
  description: z.string().nullish(),
  icon: z.string().nullish(),
  itemLevelId: z.int(),
  name: z.string(),
});
